const Colors = {
  white: '#FFFFFF',
  red: '#FF0000',
  daintree: '#02263d',
  gold: '#ffd500',
  amber: '#ffc107',
  orange: '#FF6E00',
  green: '#30D158',
  webOrange: '#FEA300',
  chartreuseYellow: '#D9FD04',
  cyan: '#1BDAFF',
  alto: '#E0E0E0',
  wildSand: '#F5F5F5',
  silverChalice: '#9E9E9E',
  black: '#000000',
  mineShaft: '#212121',
  Thunderbird: '#BE3019',
  porcelain: '#F1F3F4',
  gallery: '#EBEBEB',
  alto2: '#D3D3D3',
  abbey: '#7ed321',
  torchRed: '#FF0048',
  internationalOrange: '#FF5A00',
  welcome: '#08a045',
  sayAgain: '#9A1D85',
  readBack: '#006ba6',
  total: '#FF6C0A',
  dim: '#979dac',
  brightGreen: '#70e000',
  aiItemIndicator: '#fffdeb',
  // Order Status Banner palette (HITL-1527): stage ring, strip, retry accent.
  apple: '#6cbf3f',
  zest: '#e07a1f',
  amaranth: '#e04255',
  botticelli: '#c9d7e2',
  dell: '#3b6d11',
  chelseaGem: '#9a4d0f',
  mexicanRed: '#a32d2d',
  elephant: '#14344f',
  athsSpecial: '#ece7c8',
  geyser: '#dfe3e8',
  christine: '#ed6c02',
  redRibbon: '#f30252',
  bunker: '#0d151c',
  bittersweet: '#FC7373',
  vidaLoca: '#589317',
  guardsmanRed: '#CC0001',
  cardinalRed: 'C41E3A',
  beeswax: '#FDFAC4',
  apricot: '#FFC8BA',
  spindle: '#B9D4ED',
  teaGreen: '#CAFFBF',
  mauve: '#FFC6FF',
  // Promoted out of the pastel block below for the HITL-1501 issue-chip scheme,
  // alongside teaGreen and mauve which came from the same place. `periwinkle` is
  // named for use, not for the CSS var it came from.
  deepChampagne: '#FFD6A5',
  electricBlue: '#9BF6FF',
  periwinkle: '#BDB2FF',
  babyBlueEyes: '#A0C4FF',
  // HITL-1608, for the `language` issue-chip category. The pastel family the other
  // nine chips came from was exhausted, and the two hues left in it were both
  // unusable: light pink reads as red (the intent bar's escalation colour) and lemon
  // is a near-duplicate of `beeswax`. Mint is the nearest unclaimed slot — a
  // desaturated blue-green that reads apart from both `teaGreen` (yellow-green) and
  // `electricBlue` (saturated cyan) at chip size.
  mint: '#B5EAD7',
  cerulean: '#06bee1',
  bluishCyan: '#0797ea',
  primaryButtonTextColor: 'rgba(0,0,0,0.87)',

  //   --light-pink: #ffadadff;
  // --lemon-yellow-crayola: #fdffb6ff;
  // --tea-green: #caffbfff;
  // --mauve: #ffc6ffff;
  // --baby-powder: #fffffcff;

  // Color Palette for Items
  froly: '#ee6677',
  forestGreen: '#228833',
  sanMarino: '#4477AA',
  turmeric: '#CCBB44',
  skyBlue: '#66ccee',
  royalHeath: '#AA3377',
  texasRose: '#ffb74d',
  emerald: '#30d158',

  // Colors for intent buttons
  acknowledge: '#FFC107',
  askRepeat: '#006BA6',
  requestStaff: '#FF0048',

  // Colors for blocked ASR messages
  blockedDebounce: '#FFB366', // light orange
  blockedPendingAsr: '#CC5500', // dark orange
  blockedDefault: '#FF8C00', // default orange
};

export const sequentialItemColors = [
  Colors.froly,
  Colors.forestGreen,
  Colors.sanMarino,
  Colors.turmeric,
  Colors.skyBlue,
  Colors.royalHeath,
];

export const convertUuidToColorNumber = (id: string) => {
  if (!id) return 0;
  const lastStr = id.split('-').pop();
  return Number.parseInt(lastStr || '0', 16);
};

export default Colors;
